module.exports = __webpack_public_path__ + "img/36.7b046070.png";